import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/music", label: "Music" },
    { to: "/shows", label: "Shows" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <>
      <nav
        data-testid="navbar"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? "bg-[#080810]/95 backdrop-blur-md border-b border-[#FF5500]/20" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="font-['Bungee'] text-[#F4EFE6] text-2xl md:text-3xl tracking-wider hover:text-[#FF5500] transition-colors duration-300" data-testid="nav-logo">
            PHÖÖN
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-10">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className={`font-mono-label text-sm transition-colors duration-300 ${
                  location.pathname === link.to ? "text-[#FF5500]" : "text-[#F4EFE6]/60 hover:text-[#F4EFE6]"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Hamburger */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-[#F4EFE6] p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu-overlay"
          className="fixed inset-0 z-40 bg-[#080810]/98 backdrop-blur-lg flex flex-col items-center justify-center gap-8"
        >
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
              className={`font-['Black_Han_Sans'] text-4xl uppercase transition-colors duration-300 ${
                location.pathname === link.to ? "text-[#FF5500]" : "text-[#F4EFE6]/70 hover:text-[#F4EFE6]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
